<template>
  <div style="padding: 10px 14px">
    <h3>教育课程云免责声明</h3>
    <p>更新及生效日期：2025年10月1日</p>
    <p>
      <strong>重要提示：请您仔细阅读本协议后再进行登录操作。如您不同意本协议的任何条款，请立即停止登录和使用服务。</strong>
    </p>
    <p>本协议是您与东莞市安道光电材料制造有限公司（以下简称“安道教育”或“我们”）就登录、使用教育课程云（以下简称"本平台"）所订立的协议。</p>
    <p>当您通过账号登录本平台时，即表示您已充分阅读、理解并接受本协议的全部内容，并同意受其约束。</p>
    <p>我们有权修改本协议，修改后的协议将在本平台公布后生效。如您继续使用本平台，即视为接受修改后的协议。</p>

    <p><strong>一、服务使用风险</strong></p>
    <P>1.1 您理解并同意，登录和使用本平台存在以下风险，这些风险需由您自行承担：</P>
    <P>（1） 因不可抗力、计算机病毒、黑客攻击、系统不稳定、网络故障等原因导致的服务中断、数据丢失或其他损失；</P>
    <P>（2） 因您的设备故障、操作失误或网络环境问题导致的登录失败、使用异常或数据错误；</P>
    <P>（3） 其他非因本平台过错导致的直接或间接损失。</P>
    <P>1.2 本平台提供的服务可能存在缺陷或误差，我们不保证服务的及时性、安全性、准确性及完整性，也不保证服务一定能满足您的所有需求。</P>
    <p><strong>二、第三方内容与责任</strong></p>

    <P>2.1 本平台可能包含第三方提供的内容、链接或服务，这些内容由第三方自行负责。我们不对其真实性、合法性、准确性作任何保证，也不承担相关责任。</P>
    <P>2.2 您因使用第三方内容或服务而遭受的任何损失，需自行与第三方解决，我们对此不承担任何责任。</P>

    <p><strong>三、用户行为责任</strong></p>

    <P>3.1 您应对登录后的一切行为负责，包括但不限于：</P>
    <P>（1）妥善保管账号及密码，防止泄露或被盗用；</P>
    <P>（2） 通过账号进行的任何操作（如信息发布、数据下载、资源使用等）；</P>
    <P>（3） 遵守法律法规、平台规则及社会公德。</P>
    <P>3.2 因您违反法律法规或平台规则导致的任何法律责任或损失，需由您自行承担。若因此给我们或第三方造成损失，您应负责赔偿。</P>

    <p><strong>四、免责范围</strong></p>

    <P>4.1 在法律法规允许的最大范围内，我们不就以下事项承担责任：</P>
    <P>（1）服务中断、延迟或终止；</P>
    <P>（2） 数据丢失、泄露或篡改；</P>
    <P>（3） 用户之间或用户与第三方之间的纠纷；</P>
    <P>（4） 因您使用服务而遭受的直接或间接损失。</P>
    <P>4.2 我们有权根据需要暂停、中断或终止部分或全部服务，且无需提前通知，也不承担任何责任。</P>

    <p><strong>五、知识产权声明</strong></p>

    <P>5.1 本平台的所有内容（包括但不限于软件、界面、文字、图像、音频、视频等）的知识产权均归我们或相关权利人所有。</P>
    <P>5.2 未经我们明确授权，任何单位或个人不得以任何方式复制、传播、修改、商业使用或创造衍生作品。</P>

    <p><strong>六、法律适用与争议解决</strong></p>

    <P>（6.1 本声明的解释与适用均适用中华人民共和国法律。</P>
    <P>6.2 因本声明引起的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向我们所在地有管辖权的人民法院提起诉讼。</P>
    <p>
      <strong>七、联系我们</strong>
    </p>

    <P>如果您对本协议有任何疑问，请联系：</P>
    <P>公司：{{ activationCompany.company }}</P>
    <P>电话：400-632-8880</P>
    <P>联系人：客服专员</P>
    <P>地址：{{ activationCompany.address }}</P>
    <p>
      <strong>再次提醒：登录操作即代表您已阅读、理解并同意接受本协议所有条款的约束。</strong>
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activationCompany: {
        company: '东莞市安道光电材料制造有限公司',
        address: '广东省东莞市松山湖国际金融园C区11栋A座',
        abbreviation: '安道'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
}
</style>
